var app = angular.module('harriApp');
app.factory('SS', ['$http', '$q', 'asyncGlobalHandler', '$timeout', 'httpHelper', function ($http, $q, asyncGlobalHandler, $timeout, httpHelper) {

    /**
     * SpeedyScreen Engine
     *
     * This is the fastest data loader you will ever see in your life :P.
     *
     * @constructor
     */
    var SS = function () {

        // loaded objects
        this.loadedObjs = null;

        //this object store the original data from the server before as it is for purpose like re init list again.
        //such as re-init reverse index
        this.loadedObjsOriginal = null;

        //loaded reverse index
        this.reverseIndex = null;
        this.reverseIndexById = null;

        // load range limit
        this.loadLimit = 8;

        // id to load in the next prefetch
        this._idList2Load = [];

        // current index
        this.currentIndex = 0;

        // last index
        this.lastIndex = 0;

        this.firstLoad = true;

        this.currentBulkId = 0;

        this.currentBulkKey = 0;

        // this is object used to track the currrent objects shown on the screen
        this.loadedInDom = {};

        this.containerSelector = '#ss-content';

        this.loadingSelector = '#ss-loading';

        this.arrowsSelector = '.ss-arrow';

        this.errorSelector = '#global-error';

        this.leftArrowId = '#ss-arrow-left';
        this.rightArrowId = '#ss-arrow-right';
        this.firstCard = false;

        // each item inside the speedy screen
        this.itemIdPrefix = '#ss-item-';

        this._locked = false;

        this.forceReload = false;

        this.out_going_buffer = {}; // to prevent multiple id request

        // bulk loader http method
        this.bulkHTTPMethod = 'p';

        this.last_call_ts = null;
        this.toRef = null;

        this.loadingStatus = false;

        this.loadingProgressSelector = '#ss-progress';

        // options
        this.options = {
            'allow_pagination': false,
            'id_bulk_service': publicConfiguration.APIServerBaseURL + 'speedyScreen/list_of_applications/',


            // data map for bluck ids
            'id_bulk_data_map': function (data) {

            },

            /**
             * the request call for the next idList
             * @param loadedObjs
             * @param idList
             * @param deferred
             */
            'request_response_handler': function (objThis, deferred, currentId, idsKey) {

            }
        };

        this.showFirstPageIndicator = false;
        this.showLastPageIndicator = false;

        // track or not index overflow ( check if index reached the end of the app array )
        this.trackIndexOverFlow = false;

    };

    SS.prototype.show = function () {
        $timeout(function () {
            $('#speedy-screen-modal').modal('show');
        }, 100);
    };

    SS.prototype.hide = function () {
        $('#speedy-screen-modal').modal('hide');
    };

    SS.prototype.refreshObjects = function (newObjects) {
        var me = this;

        if (!me.loadedObjs) {
            me.loadedObjs = newObjects;
            reverseIndexObjects(me);
            return;
        }

        var resultedObjects = {};

        for (var bulkId in newObjects) {
            resultedObjects[bulkId] = [];

            for (var index in newObjects[bulkId]) {
                var itemId = newObjects[bulkId][index].id;
                var newItem = {id: itemId};

                if (me.getBucketIdById(itemId) !== false && me.getBucketIdById(itemId) >= 0) {
                    var item = me.getObjectById(itemId, me.getBucketIdById(itemId));
                    newItem.data = item.data;
                }

                resultedObjects[bulkId].push(newItem);
            }
        }

        me.loadedObjs = resultedObjects;
        reverseIndexObjects(me);
    }

    /**
     * Replace item in speedy screen with another item
     * @param oldId
     * @param newId
     */
    SS.prototype.replaceItem = function (oldId, newId) {
        if (!this.reverseIndex || !this.reverseIndexById || !this.loadedObjs) {
            return;
        }

        if (this.reverseIndex[this.getBucketIdById(oldId)] != undefined && this.reverseIndex[this.getBucketIdById(oldId)][oldId] != undefined) {

            if (this.reverseIndex[this.getBucketIdById(newId)] != undefined && this.reverseIndex[this.getBucketIdById(newId)][newId] != undefined) {
                delete this.loadedObjs[this.getBucketIdById(newId)][this.reverseIndex[this.getBucketIdById(newId)][newId]];
            }

            this.loadedObjs[this.getBucketIdById(oldId)][this.reverseIndex[this.getBucketIdById(oldId)][oldId]].id = newId;
            delete this.loadedObjs[this.getBucketIdById(oldId)][this.reverseIndex[this.getBucketIdById(oldId)][oldId]].data;

            reverseIndexObjects(this);
        }
    };

    SS.prototype.resetLoadedObjs = function () {
        this.loadedObjs = null;
        this.loadedObjsOriginal = null;
    };

    /**
     * Get object by id
     *
     * @param id
     * @param idsKey where to read from the ids list (optional)
     * @param param list of fitlers parameters
     * @returns {*}
     */
    SS.prototype.get = function (id, idsKey, params) {

        var deferred = $q.defer(),
            obj, // save the current object
            currentIndex,
            me = this,
            direction;

        id = parseInt(id);

        this.showFirstPageIndicator = false;
        this.showLastPageIndicator = false;

        me._idList2Load = [];
        if (!this.isLock()) {

            this.lock();

            // this.currentBulkId = id;

            // if the user provide idsKey.
            if (idsKey) {
                this.currentBulkKey = idsKey;
            }
            else {
                idsKey = this.currentBulkKey;
            }


            // then
            this.initIdBulk(params).then(function (data) {

                obj = me.getObjectById(id, idsKey);
                //load objects ahead
                currentIndex = me.getObjectIndex(id, idsKey);

                // loaded ?
                me.resolved = false;
                if (obj && obj.hasOwnProperty('data')) {
                    deferred.resolve(currentIndex);
                    me.unlock();
                    me.resolved = true;
                }
                else {
                    me.showLoading();
                    // show loading if we have nthn to show
                    // load on the next bulk request
                    if (!me.out_going_buffer.hasOwnProperty(id)) {
                        me._idList2Load.push(id);
                        me.bufferById(id);
                    }
                }

                //save last index
                me.lastIndex = me.currentIndex;


                if (currentIndex >= 0 && !isNaN(currentIndex)) {
                    // set current index
                    me.currentIndex = currentIndex;

                    direction = me.getDirection();
                    // load to right
                    me.loadSpatialData(parseInt(currentIndex), id, idsKey, 1);
                }

                if (!isNaN(currentIndex) && currentIndex > 0) {
                    // load to left
                    me.loadSpatialData(parseInt(currentIndex), id, idsKey, -1);
                }


                // load next page if bulk is zero
                if (me._idList2Load.length == 0) {
                    if (!nextPageBeingLoaded && me.options.allow_pagination && me.options.loadNextPage) {
                        nextPageBeingLoaded = true;
                        me.options.loadNextPage($.extend(true, {}, params), me.loadedObjs).then(function () {
                            nextPageBeingLoaded = false;
                            me.options['request_response_handler'](me, deferred, id, idsKey, me.resolved);
                        });
                    }
                }
                else {
                    me.options['request_response_handler'](me, deferred, id, idsKey, me.resolved);
                }


                me.firstLoad = false;

                me.updateProgress();

                // is first, then hide the first left arrow
                me.showLeftArrow();
                if (me.currentIndex === 0) {
                    me.hideLeftArrow();
                }


                // is last
                me.showRightArrow();
                if (!me.getNextIndex()) {
                    me.hideRightArrow();
                }



            }, function (err) {
                me.unlock();
            });
        }
        else {
            // this.showLoading();
            //deferred.resolve(this.currentIndex);
            //locked stop
        }


        return deferred.promise;
    };


    SS.prototype.updateProgress = function(){
        var index = this.currentIndex;
        var cards_counter = this.loadedObjs[this.currentBulkKey].length;

        this.progress = Math.ceil( ( (index+1) / cards_counter) * 100 );  
    };
    /**
     * This function used to maintain speedy screen id list when the user move a card
     *
     * @param bucket_id
     * @param to_bucket_id
     * @param from_item_pos
     * @param new_item_pos
     */
    SS.prototype.moveIdListEntry = function (bucket_id, to_bucket_id, from_item_pos, new_item_pos) {

        var me = this;

        if (this.loadedObjs && this.loadedObjs[bucket_id] && this.loadedObjs[bucket_id][from_item_pos]) {

            // remove from old
            var item = ar_delete(this.loadedObjs[bucket_id], from_item_pos);

            //move to
            ar_insert_after(this.loadedObjs[to_bucket_id], new_item_pos, item);

            // maintain reverse index
            delete this.reverseIndex[bucket_id][item.id];

            _.each(this.loadedObjs[to_bucket_id], function (card, index) {
                me.reverseIndex[to_bucket_id][card.id] = index;
            });

        }

    };

    /**
     * get object by id
     *
     * @param id
     * @param idsKey
     * @returns {*}
     */
    SS.prototype.getObjectById = function (id, idsKey) {
        idsKey = idsKey || this.currentBulkKey;
        var objIndex = this.reverseIndex[idsKey] && this.reverseIndex[idsKey][id];
        if (this.loadedObjs[idsKey] && this.loadedObjs[idsKey][objIndex]) {
            return this.loadedObjs[idsKey][objIndex];
        }
        else {
            return false;
        }
    };

    /**
     * getObjectByIdByBucketId
     *
     * @param id
     * @returns {*}
     */
    SS.prototype.getBucketIdById = function (id) {
        var buck = this.reverseIndexById[id];
        if (buck) {
            return buck;
        }
        else {
            return false;
        }
    };


    /**
     * getObjectByIndex
     *
     * @param objIndex
     * @param idsKey
     * @returns {*}
     */
    SS.prototype.getObjectByIndex = function (objIndex, idsKey) {
        idsKey = idsKey || this.currentBulkKey;
        return this.loadedObjs && this.loadedObjs[idsKey] && this.loadedObjs[idsKey][objIndex] ? this.loadedObjs[idsKey][objIndex] : false;
    };


    /**
     * getCurrentObject
     *
     * @param id
     * @returns {*}
     */
    SS.prototype.getCurrentObject = function () {

        if (!this.reverseIndex[this.currentBulkKey]) {
            console.log('Error this.reverseIndex[this.currentBulkKey] has not bucket id ', this.currentBulkKey)
        }

        var objIndex = this.reverseIndex[this.currentBulkKey][this.currentBulkId];

        if (!objIndex) {
            console.log('Error this.reverseIndex[this.currentBulkKey][this.currentBulkId] not found.')
        }

        return this.loadedObjs[this.currentBulkKey][objIndex];
    };


    /**
     * get object index by id
     *
     * @param id
     * @returns {*}
     */
    SS.prototype.getObjectIndex = function (id, idsKey) {
        idsKey = idsKey || this.currentBulkKey;
        if (this.reverseIndex.hasOwnProperty(idsKey) && this.reverseIndex[idsKey].hasOwnProperty(id)) {
            return this.reverseIndex[idsKey][id];
        }
        else {
            return false;
        }
    };


    /**
     * isInLoadedRange
     *
     * @param index
     * @returns {boolean|*}
     */
    SS.prototype.isInLoadedRange = function (index) {
        return this.reverseIndex.hasOwnProperty(index);
    };


    /**
     * getUnloadedFirstIndexAfter
     *
     * @param index
     * @param key
     * @param inc
     * @returns {*}
     */
    SS.prototype.getUnloadedFirstIndexAfter = function (index, key, inc) {

        var new_index = index, me = this;

        if (!me.loadedObjs[key]) {
            return false;
        }
        function has_data(index) {
            if (!me.loadedObjs[key] || !me.loadedObjs[key][index]) {
                return false
            }
            else if (me.loadedObjs[key] && me.loadedObjs[key][index] && !me.loadedObjs[key][index].data) {
                return false;
            }
            return true;
        }

        if (inc > 0) {
            for (var i = new_index; i < me.loadedObjs[key].length; i++) {
                if (!has_data(i)) {
                    break;
                }
            }
        }
        else {
            for (var i = new_index; i >= 0; i--) {
                if (!has_data(i)) {
                    break;
                }
            }
        }

        return i;
    };

    /**
     * loadSpatialData
     *
     * @param objIndex
     * @param inc
     */
    SS.prototype.loadSpatialData = function (objIndex, skipId, key, inc) {

        key = key || this.currentBulkKey; // key default to current bulk key
        inc = inc || 1; // default to increase by one
        var loadingLimit, range, me = this, loadingEdgeIndex;

        // objIndex+inc: (+inc) => to skip the current index

        // Commented to leave the decision for what to load to SS caller
        // objIndex = this.getUnloadedFirstIndexAfter(objIndex + inc, key, inc);
        loadingLimit = this.loadLimit;

        loadingEdgeIndex = objIndex + loadingLimit * inc; // multiply by inc for the sign

        // if loading edge exceed the array ?!
        if (me.loadedObjs[key] && loadingEdgeIndex > me.loadedObjs[key].length && inc > 0) {
            loadingLimit = me.loadedObjs[key].length;
        }
        // if loading edge less than ZERO
        else if (loadingEdgeIndex < 0 && inc < 0) {
            loadingLimit = 0;
        }
        else {
            loadingLimit = loadingEdgeIndex;
        }

        if (isNaN(parseInt(objIndex)) || isNaN(parseInt(loadingLimit))) {
            console.warn("ObjIndex or loadingLimit is not a number");
            return; // Nothing to do
        }

        range = _.range(parseInt(objIndex), parseInt(loadingLimit), inc);

        // fix a bug in underscore range 0
        if (loadingLimit == 0) {
            range.unshift(0);
        }

        _.each(range, function (index) {

            var item = me.loadedObjs[key] && me.loadedObjs[key][index];

            try {

                var obj = me.loadedObjs[key][index];
                // list to load
                if (!obj.data && !me.out_going_buffer.hasOwnProperty(obj.id)) {
                    me._idList2Load.push(obj.id);
                    me.buffer(index, key);
                }
            }
            catch (err) {
                // this is should never ever happen other wise we have a FATAL error !
                // something 5ara happen
                console.log(err);
            }
        });


    };


    /**
     * Remove element from buffer request
     *
     * @param id
     */
    SS.prototype.unBuffer = function (id) {
        try {
//            var index = this._idList2Load.indexOf(id);
//            if( index > - 1 ){
//                ar_delete(this._idList2Load, index);
//            }
            delete this.out_going_buffer[id];

        }
        catch (err) {
            console.log('unBuffer', err);
        }
    };


    /**
     * buffer new element
     *
     * @param index
     * @param key
     */
    SS.prototype.buffer = function (index, key) {
        try {
            this.out_going_buffer[this.loadedObjs[key][index].id] = true;
        }
        catch (err) {
            console.log('SS.prototype.buffer', err)
        }
    };

    /**
     * buffer new element by id
     *
     * @param index
     * @param key
     */
    SS.prototype.bufferById = function (id) {
        try {
            this.out_going_buffer[id] = true;
        }
        catch (err) {
            console.log('SS.prototype.buffer', err)
        }
    };


    /**
     * getDirection
     *
     * @returns {string}
     */
    SS.prototype.getDirection = function () {

        // no change
        if (this.lastIndex == this.currentIndex) {
            return 'SAME';
        }

        // move to left
        else if (this.lastIndex > this.currentIndex) {
            return 'LEFT';
        }

        // move to right
        return 'RIGHT';
    };

    /**
     * Load data bulks, called when there is no loaded data or for pagination
     * @param deferred
     * @param params
     * @returns {*}
     */
    SS.prototype.loadBulks = function (deferred, params) {
        var me = this;

        return httpHelper[me.bulkHTTPMethod](me.options['id_bulk_service'], params).then(function (data) {
            data = data.data;
            me.loadedObjsOriginal = data;
            me.loadedObjs = me.options['id_bulk_data_map'](data, me.loadedObjs);
            reverseIndexObjects(me);

            if (deferred) {
                deferred.resolve(me.loadedObjs);
            }
        }, function (err) {
            if (deferred) {
                deferred.reject('Cannot load id bulks.');
            }
        });
    };

    /**
     * Do the required reverse indexing
     * @param me
     */
    var reverseIndexObjects = function (me) {

        me.reverseIndex = {};
        me.reverseIndexById = {};

        for (var bulkId in me.loadedObjs) {

            me.reverseIndex[bulkId] = {};

            for (var ssIndex in me.loadedObjs[bulkId]) {
                me.reverseIndex[bulkId][me.loadedObjs[bulkId][ssIndex].id] = parseInt(ssIndex);
                me.reverseIndexById[me.loadedObjs[bulkId][ssIndex].id] = bulkId;
            }
        }
    };

    var lastParams = {};
    var nextPageBeingLoaded = false;

    /**
     * loadNewBulk
     */
    SS.prototype.initIdBulk = function (params, forceReload) {

        var deferred = $q.defer(), bulkRequest = null, me = this;
        this.forceReload = forceReload || false;

        /**
         if (JSON.stringify(params) != JSON.stringify(lastParams)) {
          this.forceReload = true;
        }
         */
        lastParams = params;
        // if index is undefined or object index in range


        //|| !objIndex || !this.isInLoadedRange(objIndex) @TODO replace this


        if (!this.loadedObjs || this.forceReload) {

            if (this.forceReload) {
                this.loadedObjs = null;
            }

            this.forceReload = false;
            bulkRequest = me.loadBulks(deferred, params);
        }
        else {
            deferred.resolve(this.loadedObjs);
        }

        // loading watching ..
        if (bulkRequest) {
            asyncGlobalHandler.watchPromise(bulkRequest);
        }


        // init reverse index
        return deferred.promise;
    };


    /**
     * getnext of the index or false
     */
    SS.prototype.getNext = function () {
        var next = this.loadedObjs[this.currentBulkKey][this.currentIndex + 1];
        return next ? next : false;
    };

    /**
     * getprev of the index or false
     */
    SS.prototype.getPrev = function () {
        var prev = this.loadedObjs[this.currentBulkKey][this.currentIndex - 1];
        return prev ? prev : false;
    };


    /**
     * move next
     *
     * @param cb
     */

    SS.prototype.moveNext = function (cb) {


        var me = this;

        // this is required to hide the indicators and do nothing
        if( this.showFirstPageIndicator ){
            this.showFirstPageIndicator = false;
            return;
        }
        // get next object ID
        var nextId = this.getObjectByIndex(parseInt(this.currentIndex) + 1, this.currentBulkKey);
        // send to callback
        if (nextId) {
            cb(nextId.id, me.currentBulkKey);
            this.showLastPageIndicator = false;
            this.showFirstPageIndicator = false;
        }
        else {
            this.showLastPageIndicator = true;
            this.showFirstPageIndicator = false;
//            },  me.calcAnimOutTime() );
        }
    };


    /**
     * move previous
     *
     * @param cb
     */
    SS.prototype.movePrev = function (cb) {
        var me = this;
        // this is required to hide the indicators and do nothing 
        if( this.showLastPageIndicator ){
            this.showLastPageIndicator = false;
            return;
        }

        if (this.currentIndex - 1 >= 0) {
            var isLast = this.currentIndex - 1 <= 0, prevId = this.getObjectByIndex(this.currentIndex - 1, this.currentBulkKey);
            cb(prevId.id, me.currentBulkKey, isLast);
            this.showFirstPageIndicator = false;
            this.showLastPageIndicator = false;
        }
        else {
            this.showFirstPageIndicator = true;
            this.showLastPageIndicator = false;
        }

    };

    SS.prototype.calcAnimOutTime = function () {
        var timeout = 500;
        if (this.last_call_ts && Math.abs(this.last_call_ts - new Date()) >= 500) {
            timeout = 100;
        }
        this.last_call_ts = new Date();
        return timeout;
    };

    SS.prototype.showLeftArrow = function () {
        $('#ui-ss-container').removeClass('ss-hide-left-arrow');
    };

    SS.prototype.hideLeftArrow = function () {
        $('#ui-ss-container').addClass('ss-hide-left-arrow');
    };

    SS.prototype.showRightArrow = function () {
        $('#ui-ss-container').removeClass('ss-hide-right-arrow');
    };

    SS.prototype.hideRightArrow = function () {
        $('#ui-ss-container').addClass('ss-hide-right-arrow');
    };

    /**
     * setActiveBulkKey
     *
     * @param key
     */
    SS.prototype.setActiveBulkKey = function (key) {
        this.currentBulkKey = key;
    };

    /**
     * Return the active index
     *
     * @returns {number}
     */
    SS.prototype.getActiveIndex = function () {
        return this.currentIndex;
    };

    /**
     * getNextIndex
     *
     * @returns {*}
     */
    SS.prototype.getNextIndex = function () {
        return this.getObjectByIndex(this.currentIndex + 1, this.currentBulkKey) ? this.currentIndex + 1 : false;
    };

    /**
     * getPrevIndex
     *
     * @returns {*}
     */
    SS.prototype.getPrevIndex = function () {
        return this.getObjectByIndex(this.currentIndex - 1, this.currentBulkKey) ? this.currentIndex - 1 : false;
    };


    SS.prototype.isIndexLoaded = function (index, idsKey) {
        return  this.loadedObjs && this.loadedObjs.hasOwnProperty(idsKey) &&
            this.loadedObjs[idsKey].hasOwnProperty(index) &&
            this.loadedObjs[idsKey][index].hasOwnProperty('data');
    };

    /**
     * showLoading
     *
     */
    SS.prototype.showLoading = function () {
        $(this.loadingSelector).show();
        $(this.arrowsSelector).hide();
        $(this.loadingProgressSelector).hide();
        this.loadingStatus = true;
    };

    /**
     * hideLoading
     */
    SS.prototype.hideLoading = function () {
        this.loadingStatus = false;
        $(this.loadingProgressSelector).show();
        var me = this;
        setTimeout(function () {
            $(me.loadingSelector).hide();
            $(me.arrowsSelector).show();
        }, 500);
    };


    /**
     * isLock
     */
    SS.prototype.isLock = function () {
        return this._locked;
    };


    /**
     * lock
     */
    SS.prototype.lock = function () {
        this._locked = true;
    };

    /**
     * unlock
     */
    SS.prototype.unlock = function () {
        var me = this;
        me._locked = false;

    };


    /**
     * moveCard
     *
     * @param fromBucketId
     * @param toBucketId
     * @param id
     */
    SS.prototype.moveCard = function (fromBucketId, toBucketId, id) {
        if (!this.loadedObjs[toBucketId]) {
            this.loadedObjs[toBucketId] = [];
        }

        if (!this.reverseIndex[toBucketId]) {
            this.reverseIndex[toBucketId] = {};
        }
        // get object for that id
        var obj = this.getObjectById(id, fromBucketId), index = this.getObjectIndex(id, fromBucketId);

        //load object
        this.loadedObjs[toBucketId].push(obj);

        // update the reverse index to latest element inserted in this.loadedObjs[toBucketId]
        this.reverseIndex[toBucketId][id] = this.loadedObjs[toBucketId].length - 1;

        // remove element from old loaded object
        ar_delete(this.loadedObjs[fromBucketId], index);
    };

    return SS;
}]);
